import { Box, Stack } from "@mui/material";
import { useLocation } from "react-router-dom";
import PageTitle from "src/components/Displays/PageTitle";
import { EV_PATHS, EV_ROUTES } from "src/consts/Routes/Ev";
import PageSubTitle from "src/components/Displays/PageSubTitle";
import VerticalLinearProgress from "src/components/ProgressBar/VerticalLinearProgressBar";

export const tariffCalculator = (pathname: string) => {
  switch (pathname) {
    case EV_PATHS.START:
      return 70;
    case EV_PATHS.COMPATIBILITY:
      return 95;
    case EV_PATHS.TERMS:
      return 115;
    default:
      return 70;
  }
};

const EvProgressBar = () => {
  const { pathname } = useLocation();

  return (
    <Stack
      gap="13px"
      sx={{
        display: { xs: "none", sm: "flex" },
      }}
    >
      <PageTitle text={"Menü"} />
      {EV_ROUTES.includes(pathname) && (
        <Box
          sx={{
            gap: 3,
            height: 155,
            display: { xs: "flex", sm: "default" },
          }}
        >
          <VerticalLinearProgress
            variant="determinate"
            value={155 - tariffCalculator(pathname)}
          />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "16px",
            }}
          >
            <PageSubTitle text={"Start"} />
            <PageSubTitle text={"Kompatibilität"} />
            <PageSubTitle text={"AGB"} />
            <PageSubTitle text={"SmartCar"} />
            <PageSubTitle text={"Vertrag abschließen"} />
          </Box>
        </Box>
      )}
    </Stack>
  );
};

export default EvProgressBar;
